import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "league-descriptions" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "d-flex flex-row align-items-center" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "league-name" }
const _hoisted_9 = { class: "requirement" }
const _hoisted_10 = { class: "rules" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = {
  key: 0,
  class: "item"
}

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {nextTick, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {$t} from "@/i18n";
import SvgIcon from "@/components/SvgIcon.vue";
import LoaderContent from "@/components/LoaderContent.vue";
import LeagueDTO from "@/models/LeagueDTO";
import UserDTO from "@/models/UserDTO";
import {numberFormatter} from "@/service/NumberFormatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueDescriptions',
  setup(__props) {

const state = reactive({
  leagues: [] as LeagueDTO[],
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const router = useRouter()

onMounted(async () => {
  await loader.value?.load(async () => {
    state.leagues = await api.call.leagues.list()
  });

  await nextTick()
  const user = store.getters.getUser as UserDTO|null
  if (!user) {
    return
  }

  document.getElementById(`league-${user.userLeague.league}`)?.scrollIntoView({behavior: 'smooth', block: 'start'})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoaderContent, {
    ref: (el) => loader.value = el
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push({name: 'profile'})), ["prevent"])),
          class: "nav-back"
        }, [
          _createVNode(SvgIcon, { icon: "back" }),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref($t)('profile')), 1)
        ]),
        _createElementVNode("h1", null, _toDisplayString(_unref($t)('league_descriptions')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).leagues, (league) => {
          return (_openBlock(), _createElementBlock("div", {
            key: league.league,
            id: `league-${league.league}`,
            class: "league-card"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  alt: "league",
                  src: `/img/leagues/${league.league}.png`
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref($t)(`leagues.titles.${league.league}`)), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(league.minBetSum.amount === '0'
                ? _unref($t)('league_requirement_start')
                : _unref($t)('league_requirement', {betSum: _unref(numberFormatter).formatNumber(league.minBetSum), deposits: league.minDepositsCount})), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(_unref($t)('league_wheel_of_fortune')), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref($t)('league_wheel_of_fortune_range', {min: _unref(numberFormatter).formatNumber(league.wheelMinReward), max: _unref(numberFormatter).formatNumber(league.wheelMaxReward)})), 1)
                ]),
                (league.tournaments.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", null, _toDisplayString(_unref($t)('league_tournament_start_bankroll')), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numberFormatter).formatNumber(league.tournaments[0].startBankroll)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_3))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}
}

})